import { render, staticRenderFns } from "./erikoistuvat-laakarit.vue?vue&type=template&id=0ab4f26e&"
import script from "./erikoistuvat-laakarit.vue?vue&type=script&lang=ts&"
export * from "./erikoistuvat-laakarit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports